import React from "react";
import Api from "../../../api/Api.js";
import CustomerEndpoints from "../../../api/CustomerEndpoints";
import moment from "moment";
import DataTable from "../../../components/Table/DataTable";

const columns = [
  {
    name: "For",
    options: {
      filter: true,
      sort: true,
    }
  },
  {
    name: "Ref",
    options: {
      filter: true,
      sort: true,
    }
  },
  {
    name: "Date",
    options: {
      filter: true,
      sort: true,
    }
  },
  {
    name: "Qty",
    options: {
      filter: true,
      sort: true,
    }
  },
  {
    name: "Cost / unit",
    options: {
      filter: true,
      sort: true,
    }
  },
  {
    name: "Price / unit",
    options: {
      filter: true,
      sort: true,
    }
  },
  {
    name: "Total GP",
    options: {
      filter: true,
      sort: true,
    }
  }
];

class Adhoc extends React.Component {

  state = {
    charges: [],
    loading: true,
    error: false,
    page: 0
  }

  componentDidMount() {
    Api.get(CustomerEndpoints.adhocCharges, { id: this.props.customer_id }).then(({ data }) => {
      this.setState({ charges: data, loading: false });
    }).catch((e) => {
      this.setState({ loading: false, error: true });
      console.error(e);
    })
  }

  render() {
    return (
      <DataTable
        title={"Adhoc Charges"}
        data={
          this.state.charges.map(adhoc => [adhoc.service_name, adhoc.product_reference, moment(adhoc.date).format("D MMMM YYYY - HH:mm"), adhoc.quantity, adhoc.cost, adhoc.price, adhoc.gp])
        }
        columns={columns}
        options={this.options}
      />
    );
  }
}

export default Adhoc;